<template>
  <div :class="`message message--${type}`">
    <icon v-if="iconName" :name="iconName" width="20" height="20"></icon>
    <span><slot /></span>
  </div>
</template>

<script>
  export default {
    name: 'message',
    props: ['type', 'iconName'],
  };
</script>

<style lang="sass" scoped>
  @import '~styles/component-utils.sass';
  .message
    padding: $spacing-base;
    border-radius: 3px;
    &--warning
      background: $color-warning;
      color: #fff;
    &--success
      background: $color-success;
      color: #fff;
      a
        color: $color-main-dark;
    &--error
      background: $color-error;
      color: #fff;
    svg
      float: left;
</style>



// WEBPACK FOOTER //
// Message.vue?4d572f00